module.exports = __webpack_public_path__ + "img/radio-flamingo.763dd158.svg";